import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersWeeklyReportsCumulativeAnalysisIndexResponseType,
  ApiManagersWeeklyReportsCumulativeAnalysisIndexRequestType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersWeeklyReportsCumulativeAnalysisIndexRequestType;
};

const request = async ({
  params,
}: RequestDataType): Promise<ApiManagersWeeklyReportsCumulativeAnalysisIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersWeeklyReportsCumulativeAnalysisIndexResponseType>(
      "/api/managers/weekly_reports/cumulative_analysis",
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersWeeklyReportsCumulativeAnalysisIndexRequestType;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersWeeklyReportsCumulativeAnalysisIndex = ({
  params,
  config = {},
}: PropsType = {}): UseQueryResult<ApiManagersWeeklyReportsCumulativeAnalysisIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersWeeklyReportsCumulativeAnalysisIndex", params],
    queryFn: () => request({ params }),
  });
};
